module.exports = __webpack_public_path__ + "img/_Neon Green and Purple Friendly Professional Messenger App Roadmap Presentation (1900 x 1080 px).615df95b.gif";